<template>
  <div :class="tabClasses">
    <TabStyle
      variant="ghost"
      :icon="icon"
      :size="size"
      :text="text"
      :active="active"
      :disabled="disabled"
    >
      <template v-if="$slots.default" #default>
        <slot />
      </template>
    </TabStyle>
  </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import style from "../Dropdown.module.scss";
import TabStyle from "@/elements/UI/tabs/TabStyle/TabStyle.vue";

export default defineComponent({
  name: "DropdownTab",
  components: {TabStyle},
  props: {
    text: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    size: {
      type: String as PropType<Size>,
      default: "S"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    // технические свойства
    index: {
      type: Number,
      default: 0
    },
    maxSize: {
      type: Number,
      default: 0
    }
  },
  computed: {
    positionClass(): string {
      if (this.maxSize <= 1) {
        return style.single;
      }

      if (this.index === 0) {
        return style.first;
      }

      if (this.index === this.maxSize - 1) {
        return style.last;
      }

      return style.middle;
    },

    tabClasses(): string[] {
      return [style.dropdown, style[`size${this.size}`], this.positionClass];
    }
  }
});
</script>
